import type { OrchestratorFormData } from './types';

// ============================================================================
// ORCHESTRATOR CONSTANTS
// ============================================================================

// Default user types for orchestrators
export const ORCHESTRATOR_USER_TYPES = {
  SIM_AUTO_PUBLISH: 'telemetry_sim_auto_publish',
  SIM_INSTANT: 'telemetry_sim_instant',
} as const;

// Default script names
export const SCRIPT_NAMES = {
  AHU_CHILLER_SIM: 'runAhuChillerSimulationPeriod',
} as const;

// Default task user types (the script collection user type)
export const TASK_USER_TYPES = {
  SIM_AHU_CHILLER: 'sim_ahu_chiller',
} as const;

// ============================================================================
// DEFAULT FORM VALUES
// ============================================================================

export const DEFAULT_SCHEDULED_ORCHESTRATOR: OrchestratorFormData = {
  name: 'Sim Telemetry Auto Publisher',
  description: 'Orchestrator to auto generate Telemetry',
  userType: ORCHESTRATOR_USER_TYPES.SIM_AUTO_PUBLISH,
  isInstant: false,
  scheduleHours: 0,
  scheduleMinutes: 30,
  scheduleSeconds: 0,
  taskScriptName: SCRIPT_NAMES.AHU_CHILLER_SIM,
  taskUserType: TASK_USER_TYPES.SIM_AHU_CHILLER,
  dryRun: false,
};

export const DEFAULT_INSTANT_ORCHESTRATOR: OrchestratorFormData = {
  name: 'Sim Telemetry Instant',
  description: 'Orchestrator to simulate Telemetry Instant',
  userType: ORCHESTRATOR_USER_TYPES.SIM_INSTANT,
  isInstant: true,
  scheduleHours: 0,
  scheduleMinutes: 0,
  scheduleSeconds: 0,
  taskScriptName: SCRIPT_NAMES.AHU_CHILLER_SIM,
  taskUserType: TASK_USER_TYPES.SIM_AHU_CHILLER,
  dryRun: false,
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

export function getEmptyOrchestratorForm(): OrchestratorFormData {
  return {
    name: '',
    description: '',
    userType: '',
    isInstant: true,
    scheduleHours: 0,
    scheduleMinutes: 30,
    scheduleSeconds: 0,
    taskScriptName: SCRIPT_NAMES.AHU_CHILLER_SIM,
    taskUserType: TASK_USER_TYPES.SIM_AHU_CHILLER,
    dryRun: false,
  };
}

export function formatSchedule(hours: number, minutes: number, seconds: number): string {
  return `* ${hours} ${minutes} ${seconds}`.trim();
}

export function parseSchedule(schedule?: string): { hours: number; minutes: number; seconds: number } {
  if (!schedule) return { hours: 0, minutes: 30, seconds: 0 };
  
  // Format: "* hours minutes seconds" or "hours minutes seconds"
  const parts = schedule.replace(/^\*\s*/, '').trim().split(/\s+/);
  
  return {
    hours: parseInt(parts[0]) || 0,
    minutes: parseInt(parts[1]) || 30,
    seconds: parseInt(parts[2]) || 0,
  };
}




